var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AUserProfilePic"},[_c('a-image',{staticClass:"image user-profile-image",attrs:{"alt-text":_vm.username,"image-path":_vm.profilePicUrl(),"size":_vm.imageSize || '100x100'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }